<template>
  <v-row>
    <v-col cols="12" class="text-uppercase white--text text-center">
      <h4 style="letter-spacing: 0.0892857143em;">Inbox</h4>
    </v-col>
    <v-col
      :class="emptyMessage ? 'd-flex align-center' : 'pa-0'"
      :style="emptyMessage ? { height: '90vh' } : {}"
    >
      <v-list v-if="users.length" class="h-100">
        <template v-for="user in users">
          <v-subheader v-if="user.header" :key="user.id" v-text="user.name" />

          <v-divider
            v-else-if="user.divider"
            :key="user.id"
            :inset="user.inset"
          />

          <v-list-item v-else :key="user.id" :to="`/chat/${user.id}`">
            <!-- <v-badge
                bordered
                bottom
                color="primary accent-4"
                dot
                offset-x="25"
                offset-y="20"
              >
                <v-list-item-avatar v-if="user.profilePicture">
                  <v-img :src="user.profilePicture" />
                </v-list-item-avatar>
              </v-badge> -->

            <v-list-item-avatar v-if="user.profilePicture">
              <v-img :src="user.profilePicture" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-html="user.senderName" />

              <v-list-item-subtitle
                :class="{ 'font-weight-bold black--text': user.unreadCount }"
                v-html="user.lastMessage || 'Start chating'"
              />
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                v-text="user.time"
                :class="{
                  'primary--text font-weight-bold': user.unreadCount,
                }"
              />
              <v-badge
                v-if="user.unreadCount"
                color="primary"
                :content="user.unreadCount"
                offset-x="20"
              />
              <v-icon v-else style="opacity: 0"> xmdi-star-outline </v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <template v-if="!users.length">
        <v-progress-linear v-if="loading" indeterminate />
        <looper-fallback
          v-if="emptyMessage"
          title="Your Inbox is empty."
          :message="emptyMessage"
        />
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LooperFallback from '@/components/common/LooperFallback'

export default {
  components: { LooperFallback },
  data () {
    return {
      loading: true,
      emptyMessage: '',
      category: '',
      singleArr: [],
      activeTread: null,
      channel: 'Online',
      channels: [],
      users: [],
      thread: [],
      sender: null,
      lastTimeSlow: null,
      onlineStatus: []
    }
  },
  watch: {
    activeTread (id) {
      if (id && id !== this.sender?.id) {
        this.singleMessageWindow(id)
        this.sender = this.users.find((user) => user.id === id)
      }
    }
  },
  computed: mapGetters([
    'user',
    'subscriptions',
    'userProfile',
    'fetchList',
    'updateSubscriptions',
    'messages',
    'messageCount',
    'channelGuys',
    'sendMessage',
    'globalChannel'
  ]),
  methods: {
    ...mapActions([
      'getSubscriptions',
      'getUserProfile',
      'getFetchList',
      'getUpdateSubscriptions',
      'getMessages',
      'getMessageCount',
      'getChannelGuys',
      'sendMessageNow',
      'getNotificationSnapbar',
      'getChannel'
    ]),
    // handleCloseChatThread() {
    //   this.activeTread = null;
    //   this.thread = [];
    //   this.sender = null;
    //   this.$pnClean(this.channel);
    //   this.$pnRelease(this.channel);
    //   this.channel = null;
    // },
    // presence(ps) {
    //   this.channelMeta = ps;
    //   /**Defind whos online/offline/leave/join in the inbox list */
    //   //console.log(ps);
    // },
    // status(st) {
    //   console.log(st);
    //   this.category = st.category;
    // },
    urlOrText (content) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      )
      return !!pattern.test(content)
    },
    contentType (content) {
      const isValid = this.urlOrText(content)
      if (isValid) {
        var imgExts = ['jpeg', 'jpg', 'png']
        var ext = content.split('.').pop()
        if (imgExts.indexOf(ext) !== -1) {
          return 'image'
        } else {
          return 'url'
        }
      } else {
        return 'text'
      }
    },
    unix_to_pubnub (time) {
      return time * 10000
    },
    update_channel_time (channel, time) {
      localStorage.setItem(channel, time)
    },
    async recur_fetchList (i, response) {
      var num = i || 0
      if (num < this.channels.length) {
        var receiverId = ''
        var senderName = ''
        var contactProfilePicture = ''
        var unreadCount = 0
        if (
          typeof response.channels[this.channels[num]] !== 'undefined' &&
          response.channels[this.channels[num]].length
        ) {
          if (localStorage.getItem(this.channels[num]) !== null) {
            this.lastTimeSlow = localStorage.getItem(this.channels[num])
          } else {
            this.lastTimeSlow = this.unix_to_pubnub(Math.round(+new Date()))
            this.update_channel_time(this.channels[num], this.lastTimeSlow)
          }
          /** @todo: most likely the api call updated, have to check */
          await this.getMessageCount({
            channel: this.channels[num],
            lastTimeSlow: this.lastTimeSlow
          })
          if (this.messageCount) {
            unreadCount = this.messageCount
          }
          await this.getChannelGuys({
            channel: this.channels[num]
          })
          if (this.channelGuys.get('users')[0] === this.user.id) {
            receiverId = this.channelGuys.get('users')[1]
          } else {
            receiverId = this.channelGuys.get('users')[0]
          }

          for (
            let j = 0;
            j < response.channels[this.channels[num]].length;
            j++
          ) {
            if (
              typeof response.channels[this.channels[num]][j].message
                .receiverId !== 'undefined' &&
              response.channels[this.channels[num]][j].message.receiverId ==
                this.user.id
            ) {
              senderName =
                response.channels[this.channels[num]][j].message.senderName
              contactProfilePicture =
                response.channels[this.channels[num]][j].message
                  .senderProfilePic
            }
          }
          if (senderName === '') {
            await this.getUserProfile({
              userId: receiverId
            })
            if (this.userProfile) {
              senderName =
                this.userProfile.get('firstName') +
                ' ' +
                this.userProfile.get('lastName')
              contactProfilePicture =
                typeof this.userProfile.get('profilePicture') !== 'undefined'
                  ? this.userProfile.get('profilePicture')
                  : './assets/images/defaultavatar.png'
            }
          }
          var lastLine =
            response.channels[this.channels[num]][
              response.channels[this.channels[num]].length - 1
            ].message.text
          var data = {
            id: receiverId,
            profilePicture: contactProfilePicture,
            senderName: senderName,
            lastMessage: this.urlOrText(lastLine) ? 'file' : lastLine,
            unreadCount: unreadCount,
            time: this.$moment
              .unix(
                parseInt(response.channels[this.channels[num]][0].timetoken) /
                  10000000
              )
              .startOf('hour')
              .calendar(),
            index: num
          }
          this.singleArr.push(data)
          // this.users.push(data);
          this.recur_fetchList(num + 1, response)
        } else {
          this.recur_fetchList(num + 1, response)
        }
      } else {
        /** Push all array items together */
        this.users = this.singleArr
        this.loading = false
      }
    }
  },
  async created () {
    await this.getSubscriptions({
      id: this.user.id
    })
    if (this.subscriptions !== null && this.subscriptions.length) {
      this.channels = this.subscriptions
      /** Fetch all the message history */
      await this.getFetchList({
        channels: this.channels
      })
      if (this.fetchList && Object.keys(this.fetchList.channels).length > 0) {
        await this.recur_fetchList(0, this.fetchList)
      } else {
        this.loading = false
        this.emptyMessage =
          'Your inbox is currently empty, all future messages will appear here'
      }
    } else {
      this.loading = false
      this.emptyMessage =
        'Your inbox is currently empty, all future messages will appear here'
    }

    /** Always null the channel when users are here. */
    await this.getChannel({
      channel: null
    })
  }
}
</script>
